import script from "./NkLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./NkLogin.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__